<script>
  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();

  function nextStep() {
    dispatch("nextStep");
  }
</script>

<div class="text-center">
  <h2 class="mb-3">Bienvenue</h2>
  <div class="pref">

    <p>
      Avant de saisir ce formulaire nous vous invitons à préparer les informations suivantes qui seront nécessaire à la souscription du contrat :
    </p>
  <ul>
    <li>Numéro SIRET</li>
    <li>Date de création de l'activité</li>
    <li>Relevé d'identité bancaire </li>
  </ul>
  </div>
  <button class="btn btn-primary" on:click={nextStep}>Commencer le formulaire</button>
</div>


<style>
  .pref {
    text-align: left;
  }
</style>